import { Stack } from '@mui/material'
import { useGetMetricReport } from '@/service-library/hooks/metrics'
import { ByTimeMetricReport } from '@/types/workflow-metric-reports'
import ByTimeAndStateMetricLineChart, {
  ByTimeAndStateMetricLineChartProps,
} from '../ByTimeAndStateMetricLineChart'
import ChartCard, { ChartCardProps } from '../ChartCard'
import MetricsStatesFilter, {
  useWorkflowSelectedStateIds,
} from '../MetricsStatesFilter'
import { DateRange } from '../ProjectMetricsDashboard'
import { CommonQueryOptions } from '../types'

type IdleDocumentsCountCardProps = {
  commonQueryOptions: CommonQueryOptions & {
    filters: Required<CommonQueryOptions['filters']>
  }
  reportKey: string
  selectedDateRange: DateRange
  type: ByTimeAndStateMetricLineChartProps['type']
  height?: number
} & Omit<ChartCardProps, 'children'>

export default function ByTimeAndStateMetricLineCard({
  reportKey,
  commonQueryOptions,
  selectedDateRange,
  type,
  height,
  ...chartCardProps
}: IdleDocumentsCountCardProps) {
  const { report } = useGetMetricReport<ByTimeMetricReport>({
    ...commonQueryOptions,
    reportKey,
  })

  const {
    allStateIds,
    filteredStateIds,
    selectedStateIds,
    setSelectedStateIds,
  } = useWorkflowSelectedStateIds({
    key: reportKey,
    report,
  })

  const metricsFilter = (
    <MetricsStatesFilter
      allStateIds={allStateIds}
      selectedStateIds={selectedStateIds}
      setSelectedStateIds={setSelectedStateIds}
    />
  )

  return (
    <ChartCard
      {...chartCardProps}
      controls={
        chartCardProps.controls ? (
          <Stack direction="row" spacing={1} alignItems="center">
            {chartCardProps.controls}
            {metricsFilter}
          </Stack>
        ) : (
          metricsFilter
        )
      }
    >
      <ByTimeAndStateMetricLineChart
        type={type}
        report={report}
        filteredStateIds={filteredStateIds}
        groupBy={commonQueryOptions.filters.grouped_by}
        selectedDateRange={selectedDateRange}
        height={height}
      />
    </ChartCard>
  )
}
